import {
  CONVERSATION_TYPES
} from '../../config/constants'

const {NORMAL, EXPERT, GROUP} = CONVERSATION_TYPES

import initiateConversation, {initiateGroupChatRefForUser} from './initiate_conversation'
import setConversationStack from './conversation_stack'
import getConversationStack from '../getters/conversation_stack'
import getFocusedConversation from '../getters/focused_conversation'
import getStackVisibleSlot from '../getters/stack_visible_slot'
import addConversationToStack from '../helpers/add_conversation_to_stack'

const updateConversationStack = (currentUserUid, targetId, type, viewportType, conversationId) => {
  const focused = getFocusedConversation()
  const visibleSlot = getStackVisibleSlot()

  return getConversationStack(currentUserUid)
    .then(addConversationToStack.bind(null, conversationId, targetId, focused, visibleSlot, type))
    .then(setConversationStack.bind(null, currentUserUid, viewportType))
}

export default (currentUserUid, targetId, conversationId, type, viewportType) => {
  if (!conversationId) {
    if (type === NORMAL || type === EXPERT) {
      return initiateConversation(currentUserUid, targetId)
        .then(updateConversationStack.bind(null, currentUserUid, targetId, type, viewportType))
    }
    else if (type === GROUP) {
      return initiateGroupChatRefForUser(currentUserUid, targetId)
        .then(updateConversationStack.bind(null, currentUserUid, targetId, type, viewportType))
    }
  }
  else {
    return updateConversationStack(currentUserUid, targetId, type, viewportType, conversationId)
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/open_conversation.js
 **/